export const WORKLET_PROCESSOR_NAME = "spessasynth-worklet-processor";
